import api from './api';

export const adminService = {
  listarUsuarios:    ()           => api.get('/admin/usuarios'),
  crearUsuario:      (data)       => api.post('/admin/usuarios', data),
  actualizarUsuario: (id, data)   => api.put(`/admin/usuarios/${id}`, data),
  eliminarUsuario:   (id)         => api.delete(`/admin/usuarios/${id}`),

  obtenerContadores:    ()       => api.get('/admin/contadores'),
  actualizarContadores: (data)   => api.put('/admin/contadores', data),

  listarTiposIva:  ()            => api.get('/admin/tipos-iva'),
  crearTipoIva:    (porcentaje)  => api.post('/admin/tipos-iva', { porcentaje }),
};
